import { createSelector } from 'reselect';
import { getDataSelector } from 'redux/selectors';

export const invitationCountSelector = createSelector(
  getDataSelector('sellers', 'sellers'),
  state => state.filter(contact =>
    contact.get('requestorId') && contact.get('requestorId') === contact.get('sellerId') && !contact.get('isDeleted')).size,
);
